import { FilteredRequest } from '../common/interfaces';

export interface ReasonsRequest {
  actions?: ActionType[];
  name?: string;
  isActive?: boolean;
  createdBy?: string;
  $ids?: string[];
  $orderBy?: string;
  $order?: 'asc' | 'desc';
}

export interface ActionReason {
  id: string;
  createdBy: string;
  action: string;
  name: string;
  description: string;
  isActive: boolean;
  createdAt: string;
}

export enum ActionType {
  OfficialRejectVerification = 'OFFICIAL_REJECT_VERIFICATION',
  SellerRejectOrder = 'SELLER_REJECT_ORDER',
  SellerRejectBid = 'SELLER_REJECT_BID',
  BuyerRejectDelivery = 'BUYER_REJECT_DELIVERY',
  UserArchiveS2CToken = 'USER_ARCHIVE_S2S_TOKEN',
}

export type ListApplicationsRequest = FilteredRequest<{
  name?: string;
  friendlyName?: string;
  names?: string[];
  $resolveImages?: boolean;
}>;

export interface Application {
  name: string;
  friendlyName: string;
  description: string;
  logoUrl: string | null;
  isEncrypted: boolean;
  createdAt: string;
  updatedAt: string;
}